import { render, staticRenderFns } from "./labelTemplateEdit.vue?vue&type=template&id=06567d5a&scoped=true"
import script from "./labelTemplateEdit.vue?vue&type=script&lang=js"
export * from "./labelTemplateEdit.vue?vue&type=script&lang=js"
import style0 from "./labelTemplateEdit.vue?vue&type=style&index=0&id=06567d5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06567d5a",
  null
  
)

export default component.exports